import { Controller } from "stimulus"
import { EventTrackerService } from "../services/event_tracker_service"

export default class extends Controller {
  initialize() {
    this.info = JSON.parse(this.data.get("data"))
    this.current_user = this.info.user
    this.topic = this.info.topic
    this.messageboard = this.info.messageboard
    this.gamification_action_logs_path = this.info.gamification_action_logs_path
    this.post_length = 0;
    this.search_length = 0;
    this.topic_length = 0

    this.eventTracker = new EventTrackerService();

    this.log_gamification_post = () => {
      let href = document.location.href.split("/");
      let board = href[href.length - 2];
      $.ajax({
        method: 'POST',
        url: this.gamification_action_logs_path,
        data: {
          action_log: {
            action: 'Posted to the community forum',
            properties: {
              category: board
            }
          }
        }
      });
    }

    this.log_gamification_topic = () => {
      let href = document.location.href.split("/");
      let board = href[href.length - 1];
      $.ajax({
        method: 'POST',
        url: this.gamification_action_logs_path,
        data: {
          action_log: {
            action: 'Posted to the community forum',
            properties: {
              category: board
            }
          }
        }
      });
    }
  }

  connect() {
    $(".thredded--messageboard").on("click", function(event) {
      var href = $(event.currentTarget).attr("href").split("/");
      var board = href[href.length - 1];

      const eventProperties = {
        'board_type':board,
        'url':document.location.href,
        'page_name':document.title
      }

      this.eventTracker.trackEvent('Forum - Clicked Board Link', eventProperties);
    }.bind(this));

    $(".thredded--topics--title").on("click", function(event) {
      if(document.location.href.includes("?q=")) {
        const eventProperties = {
          'topic_text':$(event.currentTarget)[0].innerText,
          'url':document.location.href,
          'page_name':document.title
        }
        this.eventTracker.trackEvent('Forum - Clicked Search Result', eventProperties);
      } else {
        const eventProperties = {
          'topic_text':$(event.currentTarget)[0].innerText,
          'url':document.location.href,
          'page_name':document.title
        }
        this.eventTracker.trackEvent('Forum - Clicked Topic Link', eventProperties);
      }
    }.bind(this));

    $("#q").on("change paste keyup", function() {
      this.search_length = $('#q').val().length;
    }.bind(this));

    $("#post_content").on("change paste keyup", function(){
      this.post_length = $("#post_content").val().length;
    }.bind(this));

    $(".thredded--form-list.on-top").on("change paste keyup", function(){
      this.topic_length = $('#topic_title').val().length + $('#topic_content').val().length;
    }.bind(this));

    $(".thredded--main-section.thredded--topics").submit(function() {
      const eventProperties = {
        'topic_text': $('#topic_title')[0].value,
        'url': document.location.href,
        'page_name': document.title,
        'board_type': this.messageboard && this.messageboard.name
      }
      this.eventTracker.trackEvent('Forum - Submitted Topic', eventProperties);

      if(this.current_user)
        this.log_gamification_topic();
    }.bind(this));

    $(".thredded--form.thredded--post-form").submit(function() {
      const eventProperties = {
        'post_length': this.post_length,
        'url': document.location.href,
        'page_name': document.title,
        'topic_text': this.topic && this.topic.title,
        'board_type': this.messageboard && this.messageboard.name
      }
      this.eventTracker.trackEvent('Forum - Submitted Post', eventProperties);

      if(this.current_user)
        this.log_gamification_post();
    }.bind(this));

    $(".thredded--post--dropdown--actions--item").on("click", function(event) {
      if($(event.currentTarget)[0].innerText) {
        var action = $(event.currentTarget)[0].innerText;
      }else if($(event.currentTarget)[0].value) {
        var action = $(event.currentTarget)[0].value;
      }
      const eventProperties = {
        'setting_type':action,
        'url':document.location.href,
        'page_name':document.title
      }
      this.eventTracker.trackEvent('Forum - Selected Post Setting', eventProperties);
    }.bind(this));

    $('form.custom__thredded__navigation__search-topics').submit(function(event) {
      const eventProperties = {
        'search_text': $(event.currentTarget)[0][1].value,
        'url':document.location.href,
        'page_name':document.title
      }
      this.eventTracker.trackEvent('Forum - Submitted Search', eventProperties);
    }.bind(this));
  }

  disconnect(){
    if (this.post_length > 0) {
      const eventProperties = {
        'post_length': this.post_length,
        'url': document.location.href,
        'page_name': document.title,
        'topic_text': this.topic && this.topic.title,
        'board_type': this.messageboard && this.messageboard.name
      }
      this.eventTracker.trackEvent('Forum - Typed Post Content', eventProperties);
      this.post_length = 0;
    }
    if (this.topic_length > 0) {
      const eventProperties = {
        'topic_text': $('#topic_title').val() + ' : ' + $('#topic_content').val(),
        'topic_length': this.topic_length,
        'url': document.location.href,
        'page_name': document.title,
        'board_type': this.messageboard && this.messageboard.name
      }
      this.eventTracker.trackEvent('Forum - Typed Topic Content', eventProperties);
    }
    if(this.search_length > 0) {
      const eventProperties = {
        'search_length': this.search_length,
        'url': document.location.href,
        'page_name': document.title
      }
      this.eventTracker.trackEvent('Forum - Typed Search Content', eventProperties);
    }
  }
}
